import plan from '../data/address-plan.json';
import type { NetworkWorld } from '../types/network';

const LEGACY_PREFIX = '192.168.10.';
const MASK = '255.255.192.0';

/** Old saves retain their chapter, cable states and player edits while addresses migrate. */
export function migrateAddressPlan(world: NetworkWorld): void {
  if (world.devices['router-main']?.ip.address !== `${LEGACY_PREFIX}1`) return;

  const address = (value: string | null): string | null => {
    if (!value?.startsWith(LEGACY_PREFIX)) return value;
    const host = Number(value.slice(LEGACY_PREFIX.length));
    const department = plan.find(dept => dept.legacyHosts.includes(host)) ?? plan[0];
    return `${department.gateway.slice(0, department.gateway.lastIndexOf('.'))}.${host}`;
  };
  const subnet = (value: string): string => {
    if (value === `${LEGACY_PREFIX}0/24`) return '10.0.0.0/8';
    if (value === `${LEGACY_PREFIX}56/29`) return '10.0.192.0/18';
    return value.replace(/192\.168\.10\.\d{1,3}/g, match => address(match) ?? match);
  };

  for (const device of Object.values(world.devices)) {
    const ip = device.ip;
    const department = device.id === 'rogue-router' ? plan[0]
      : plan.find(dept => dept.rooms.includes(device.roomId)) ?? plan[0];
    ip.address = address(ip.address);
    if (ip.subnetMask === '255.255.255.0') ip.subnetMask = MASK;
    ip.gateway = ip.gateway === `${LEGACY_PREFIX}1` ? department.gateway : address(ip.gateway);
    ip.dnsServers = ip.dnsServers.map(value => address(value) ?? value);
    for (const [host, value] of Object.entries(device.dnsRecords ?? {})) {
      device.dnsRecords![host] = address(value) ?? value;
    }
    for (const rule of device.firewallRules ?? []) {
      rule.srcSubnet = subnet(rule.srcSubnet);
      rule.dstSubnet = subnet(rule.dstSubnet);
    }
  }
  world.devices['router-main'].ipInterfaces = plan.slice(1).map(dept => ({
    address: dept.gateway, subnetMask: MASK,
  }));
}
